import { addHours, format } from "date-fns";
import { formatCurrency } from "../utils/FormatCurrency";
import { Tooltip } from "primereact/tooltip";
import { colunaBoletoBody, termoBody } from "./ColumnBodys";

export const criaColunasCobrancas = [
  {
    field: "cobranca_descricao",
    style: { minWidth: "20vh" },
    header: "Descrição",
  },
  {
    field: "valor_pagamento_sem_desconto",
    style: { minWidth: "11vh" },
    header: "Valor Corrigido",
    body: (rowData) => formatCurrency(rowData.valor_pagamento_sem_desconto),
  },
  {
    field: "valor_para_pagamento",
    style: { minWidth: "11vh" },
    header: "Valor com Desconto",
    body: (rowData) => formatCurrency(rowData.valor_para_pagamento),
  },
  {
    field: "data_vencimento",
    //style: {minWidth:"15%" },
    header: "Vencimento",
    body: (rowData) => format(addHours(new Date(rowData.data_vencimento), 3), "dd/MM/yyyy"),
  },
  {
    field: "protesto_status",
    //style: { minWidth: "20%" },
    header: "Status",
    body: (rowData) =>
      rowData.disponivel_parcial
        ? rowData.protesto_status === "ENVIADO"
          ? "PROTESTADO"
          : "EM ABERTO"
        : "INDISPONÍVEL",
  },
];

// export const criaColunasNegociadas =
//   (
//     [
//       {
//         field: "cobranca_data_vencimento",
//         header: "Vencimento",
//         style: { textAlign: "left" },
//         //  body: (rowData) => format(parseISO(rowData.data_vencimento_primeiro_boleto),"dd/MM/yyyy")
//       },
//       // {
//       //   field: "cobranca_create",
//       //   header: "Data Criação",
//       //   body: (rowData) => format(new Date(rowData.cobranca_create),'dd/MM/yyyy HH:mm:ss'),
//       // },
//       {
//         field: "boleto_valor",
//         header: "Valor Boleto",
//         style: { textAlign: "right" },
//         body: (rowData) => rowData.cobranca_observacao === 'EM PROCESSAMENTO' ?
//         (<>
//         <Tooltip target=".em-processamento" position="bottom" />
//         <span
//         data-pr-tooltip= "Os boletos desta negociação estão sendo gerados, volte mais tarde para ver os boletos restantes"
//         className="bg-yellow-500 text-yellow-900 p-2 rounded-md em-processamento">
//           EM PROCESSAMENTO
//         </span>
//         </>
//         ) :
//         formatCurrency(rowData.cobranca_total_pagamento),
//       },
//       {
//         field: "",
//         header: "Baixar Boleto",
//         style: { textAlign: "right" },
//         body: (rowData) => rowData.protesto_status === "ENVIADO" ? "NEGOCIAÇÃO PROTESTADA" :
//           colunaBoletoBody(rowData.boletos)
//       },
//       // {
//       //   header: "Baixar Termo",
//       //   style: {textAlign: "center"},
//       //   body: (rowData) => termoBody(rowData)
//       // },
//     ]
//   )
